<template>
    <div style="position: relative;" :class="classe[0]">
      <!-- Text xhr select {{ this.listagem.length }} <br>
      value {{ this.$props.value }}  -->

      <!-- {{ this.$props.parameters }} -->
      <div class="d-flex">
        <FormulateInput          
            :name="name"
            type="text"
            :label="label"
            :validation="validation"     
            :placeholder="placeholder"
            :class="this.$props.classe[1] + ' col-10 pa-0'"
            v-model="textoDigitado"
            :readonly="readonly || loading"
            @blur="fecharListagem"
            @focus="focusInput"
            style="margin-bottom: 0px !important;"
            autocomplete="off"
        />
        <div class="col-2 pa-1 d-flex flex-row justify-space-between mt-4">
          <SGPFormBotaoComponent
            v-if="!filtroSelecionado"
            color="success"
            class="float-right mt-1"
            small
            icon
            @mousedown.prevent
            @click="buscarDados"
            :disabled="loading"
          >
            <SGPIconComponent
              :icon="loading ? 'mdi-dots-horizontal' : 'mdi-magnify'"
              :class="loading ? 'loading-dots' : ''"
            />
          </SGPFormBotaoComponent>

          <SGPIconComponent 
            v-if="mostrarIconeStatus"
            :icon="filtroSelecionado ? 'mdi-check-circle' : 'mdi-close-circle'" 
            :color="filtroSelecionado ? '#198754' : '#df323b'" 
          />
        </div>
      </div>

      <div
        class="dropdown"
        v-if="listagem.length && exibirListagem"
      >
        <div
          v-for="(item, index) in listagem"
          :key="index"
          class="dropdown-item"
          @click="itemSelecionado(item)"
        >
          {{ getLabelList(item) }}
        </div>
      </div>

    </div>
</template>
<script>

export default {
  name: "TextXhrSelectComponent",

  props: {
    configInput: {
      type: Object,
      required: true
    },
    parameters: {
      type: Object,
      required: false
    },
    value: {
      type: Object,
      required: false
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    placeholder: {
      type: String,
      required: true,
    },    
    classe: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      textoDigitado: '',
      textoConsultado: '',
      listagem: [],
      exibirListagem: false,
      selecionado: false,
      loading: false,
      buscaRealizada: false
    }
  },

  computed: {
    filtroSelecionado () {
      return this.selecionado
    },

    mostrarIconeStatus() {
      return this.buscaRealizada && !this.loading && (this.selecionado || this.listagem.length === 0)
    }
  },

  methods: {
    async callDynamicAction(actionName, payload) {
      return await this.$store.dispatch(actionName, payload);
    },

    actionNameExists(actionName)
    {
      return Object.prototype.hasOwnProperty.call(this.$store._actions, actionName);
    },

    payload() {
      return {
        [this.$props.configInput.namePayload] : this.textoDigitado,
        ...this.getParameters()
      }
    },

    getParameters() {
      let jsonParameters = {};
      if (this.$props.configInput.getParameters.length) {
        this.$props.configInput.getParameters.forEach(obj => {
          let valueKey = this.getValueByPath(this.$props.parameters, obj?.path)
          if (valueKey != 'undefined') {
            jsonParameters[obj?.payloadKey] = valueKey
          }          
        });
      }
      return jsonParameters      
    },

    requiredParameters() {      
      if (this.$props.configInput?.requiredParameters) {
        if (this.$props.configInput?.requiredParameters.length) {
          this.$props.configInput.requiredParameters.forEach(obj => {
            let valueKey = this.getValueByPath(this.$props.parameters, obj?.path)          
            if (valueKey != 'undefined' && valueKey != '') {
              this.$props.readonly = false
            } else {
              this.$props.readonly = true
              this.textoDigitado = ''
              this.textoConsultado = ''
              this.listagem = []
              this.exibirListagem = false
              this.buscaRealizada = false
            }          
          });
        }
      }
    }, 

    returnParameters(item) {
      let jsonParameters = [{
        "name" : this.$props.name,
        "model" : this.getKeyList(item)
      }]
      
      if(this.$props.configInput?.returnParameters) {        
        if (this.$props.configInput?.returnParameters.length) {
          this.$props.configInput?.returnParameters.forEach(obj => {
            let valueKey = this.getValueByPath(item, obj?.path)
            if (valueKey != 'undefined') {
              jsonParameters.push({
                "name" : obj?.payloadKey,
                "model" : valueKey
              })
            }          
          });
        }
      }
            
      return jsonParameters      
    },

    async buscarDados() {
      if(this.textoDigitado.trim().length && !this.loading) {
        if (this.actionNameExists(this.$props.configInput?.actionName)) {
          this.loading = true
          this.buscaRealizada = false
          try {
            this.listagem = await this.callDynamicAction(this.$props.configInput?.actionName, this.payload())
            this.textoConsultado = this.textoDigitado
            this.exibirListagem = true
            this.buscaRealizada = true
          } catch (error) {
            this.listagem = []
            this.exibirListagem = false
            this.buscaRealizada = true
          } finally {
            this.loading = false
          }
        }
      }
    },

    fecharListagem() {
      setTimeout(() => {
        if (!this.loading) {
          this.exibirListagem = false
        }
      }, 500)     
    },

    async focusInput() {
      if (this.value == '' && this.textoDigitado != '') {
        this.exibirListagem = this.listagem.length > 0
      }
    },

    getValueByPath(obj, path) {
      const result = path.split('.').reduce((acc, key) => {
        if (Array.isArray(acc)) {
          // Acessa a chave em cada item do array
          return acc.map(item => item[key]).filter(v => v !== undefined);
        }
        return acc && acc[key];
      }, obj);

      if (Array.isArray(result)) {
        // Se for array, junta os valores em uma string
        return result.filter(v => v !== undefined && v !== null).join(', ');
      }

      // Retorna string simples ou string vazia
      return result !== undefined && result !== null ? String(result) : '';
    },

    getKeyList(item) {
      return (this.$props.configInput.keyList in item) ? item[this.$props.configInput.keyList] : item['id']
    },

    getLabelList(item) {
      let labelList = ''
      if(this.$props.configInput.labelList.length) {
        this.$props.configInput.labelList.forEach((value, index) => {
          if (index > 0) {
            labelList += ' - '
          }
          labelList += item[value]
        });
      }
      return labelList
    },

    itemSelecionado(item) {
      let labelSelecionado = this.getKeyList(item)
      this.textoDigitado = labelSelecionado
      this.textoConsultado = labelSelecionado
      this.value = this.getKeyList(item)
      this.exibirListagem = false
      this.selecionado = true

      this.$emit('update', 
        this.returnParameters(item)
      )
    },

    limparSelecao() {
      this.selecionado = false

      let jsonParameters = [{
        "name" : this.$props.name,
        "model" : ''
      }]
      
      if(this.$props.configInput?.returnParameters) {        
        if (this.$props.configInput?.returnParameters.length) {
          this.$props.configInput?.returnParameters.forEach(obj => {
            jsonParameters.push({
                "name" : obj?.payloadKey,
                "model" : ''
              })        
          });
        }
      }

      this.$emit('update', jsonParameters)
    }
  },

  watch: {
    value () {
      if (this.$props.value != '' && 
          this.textoDigitado == '' && 
          this.textoConsultado == ''
      ) {
        this.textoDigitado = this.$props.value
        this.textoConsultado = this.$props.value     
        this.selecionado = true   
        this.buscaRealizada = true
      } else {
        if (this.$props.value == '' &&
            this.textoDigitado == this.textoConsultado
        ) {
          this.textoDigitado = ''
          this.textoConsultado = ''
          this.buscaRealizada = false
        }
      }     
    },

    textoDigitado(newValue) {
      if (this.selecionado && newValue !== this.textoConsultado) {
        this.limparSelecao()
        this.buscaRealizada = false
        this.textoConsultado = newValue
      }
    },

    parameters () {
      this.requiredParameters()
    }
  }
}
</script>

<style scoped>
.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 160px; /* Aproximadamente 5 itens visíveis */
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  margin-left: 12px;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.loading-dots {
  animation: blink 1.4s infinite;
}
</style>